<template>
  <div class="old_new">
    <div class="top_wrap">
      <div class="header_wrap">
        <div class="choice_city">
          <div class="city" @click="choiceCity">
            <!-- <van-icon name="location-o" class="location" /> -->
            <span style="color:#EAF5F1">城市：</span>
            <span>{{ city }}</span>
            <van-icon
              name="arrow-down"
              size="12"
              color="#FFFFFF"
              style="margin-left:5px"
            />
          </div>
          <div class="project" @click="choiceProject">
            <span style="color:#EAF5F1">项目：</span>
            <span>{{ project }}</span>
            <van-icon
              name="arrow-down"
              size="12"
              color="#FFFFFF"
              style="margin-left:5px"
            />

            <!-- <img src="../../common/images/forward.png" alt /> -->
          </div>

          <van-popup
            v-model="cityshow"
            position="bottom"
            :style="{ height: '50%', width: '100%' }"
          >
            <van-picker
              title="选择公司"
              show-toolbar
              :columns="cityList"
              @confirm="onConfirm"
              @cancel="onCancel"
            />
          </van-popup>

          <van-popup
            v-model="projectshow"
            position="bottom"
            :style="{ height: '50%', width: '100%' }"
          >
            <van-picker
              title="选择项目"
              show-toolbar
              :columns="projectcol"
              @confirm="Confirm"
              @cancel="Cancel"
            />
          </van-popup>
        </div>
        <div class="search-btn">
          <img
            @click="toSearchHandle"
            src="../../common/images/oldnew/search_btn.png"
          />
        </div>
        <div class="recommended">
          <!-- <div class="recommended" v-if="!dataShow"> -->
          <div class="wrap">
            <div>当日新推荐&nbsp;&nbsp;&nbsp;&nbsp;{{ currentNum + "人" }}</div>
            <div>
              项目共推荐&nbsp;&nbsp;&nbsp;&nbsp;{{ projectAllNum + "人" }}
            </div>
          </div>
        </div>

        <!-- <div class="no_wrap" v-else></div> -->
        <div class="undistributed">
          <div class="choice_module" @scroll="scrollEvent" ref="scrollModule">
            <div
              @click="checked(0)"
              :class="{ checked: 0 == checkedBg ? true : false }"
            >
              <span>数据展示</span>
            </div>
            <div
              @click="checked(1)"
              :class="{ checked: 1 == checkedBg ? true : false }"
            >
              <span>客户分配</span>
            </div>
            <div
              @click="checked(2)"
              :class="{ checked: 2 == checkedBg ? true : false }"
            >
              <span>客户跟进</span>
            </div>
            <div
              @click="checked(3)"
              :class="{ checked: 3 == checkedBg ? true : false }"
            >
              <span>客户待审</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <data-display
        v-if="checkedBg === 0"
        :projectCode="projectCode"
        :orgCode="orgCode"
      />

      <Distribution v-if="checkedBg === 1" :projectCode="projectCode" />
      <Follow
        v-if="checkedBg === 2"
        :projectCode="projectCode"
        :orgCode="orgCode"
      />
      <Pending
        v-if="checkedBg === 3"
        :projectCode="projectCode"
        :orgCode="orgCode"
      />
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";
import { Picker, Popup, Icon } from "vant";
import * as api from "@/api";

import DataDisplay from "./OldNewComponent/dataDisplay";
import Distribution from "./OldNewComponent/distribution";
import Follow from "./OldNewComponent/follow";
import Pending from "./OldNewComponent/pending";
// import ToAudit from "./toAudit";
// import BringNew from "./bringNew";
export default {
  name: "OldNew",
  data() {
    return {
      // 加载中
      loadingStatus: false,
      treated: false,
      untreated: false,
      undistributed: true,
      toAudit: false,
      bringNew: false,
      checkedBg: 1,
      activeNames: 1,
      closeIcon: require("@/common/images/recommend/select_close.png"),
      openIcon: require("@/common/images/recommend/select_open.png"),
      columns: [],
      projectcol: [],
      cityshow: false,
      projectshow: false,
      city: "",
      projectData: "",
      orgCode: "",
      project: "",
      projectCode: "",
      cityList: [],
      cityData: [],
      projectList: [],
      undistributionList: [],
      currentNum: 0,
      projectAllNum: 0,
      undistributeNum: 0,
      allOldbeitnewRecommendNum: 0,
      allPendingAuditNum: 0,
      token: "",
      consultant: "",
      showList: true,
      untreatedNum: 0,
      treatedNum: 0,
      cityPermission: [], //城市权限
      auditNum: 0,
      projectScroll: 0,
      loading: false,
      finished: false,
      load_more: false, // 是否加载更多
      nowpage: 1, // 当前页数
    };
  },
  components: {
    "van-picker": Picker,
    "van-popup": Popup,
    "van-icon": Icon,
    // ToAudit,
    // BringNew,
    DataDisplay,
    Distribution,
    Follow,
    Pending,
    loading,
  },
  created() {
    this.loadingStatus = false;
    document.title = "老带新推荐";
    //app返回
    // this.$jsBridge.callHandler("dispatchBackBtn");
    // this.$jsBridge.registerhandler("onBackPressed", () => {
    //   this.$jsBridge.commonCall("finish", ""); //返回到app菜单
    // });
    //审核详情页返回
    if (this.$route.params.from === "detail") {
      this.project = this.$store.state.project;
      this.city = this.$store.state.city;
      this.projectCode = this.$route.params.projectCode;
      //移动端查看推荐个数统计
      api.getNumByProjectCode({ projectCode: this.projectCode }).then((res) => {
        this.currentNum = res.body.currentNum;
        this.projectAllNum = res.body.projectAllNum;
        this.undistributeNum = res.body.undistributeNum;
        this.untreatedNum = res.body.allocatedUntreatNum;
        this.treatedNum = res.body.allocatedProcessedNum;
        this.allPendingAuditNum = res.body.allPendingAuditNum;
        this.allOldbeitnewRecommendNum = res.body.allOldbeitnewRecommendNum;
      });

      //获取城市列表
      api.getDataPermission().then((res) => {
        this.cityData = res.body;

        if (this.cityData.length !== 0) {
          this.cityData.forEach((item) => {
            this.cityList.push(item.label);
          });

          this.cityData.forEach((city) => {
            if (this.city === city.label) {
              this.orgCode = city.id;
              this.projectData = city;
            }
          });

          this.projectData.children.forEach((item) => {
            this.projectcol.push(item.label);
          });

          //移动端查看推荐个数统计
          api
            .getNumByProjectCode({
              projectCode: this.projectCode,
            })
            .then((res) => {
              this.currentNum = res.body.currentNum;
              this.projectAllNum = res.body.projectAllNum;
              this.undistributeNum = res.body.undistributeNum;
              this.untreatedNum = res.body.allocatedUntreatNum;
              this.treatedNum = res.body.allocatedProcessedNum;
              this.allPendingAuditNum = res.body.allPendingAuditNum;
              this.allOldbeitnewRecommendNum =
                res.body.allOldbeitnewRecommendNum;
            });

          // 获取用户权限
          this.$jsBridge.callHandler("getAuthResources", "", (res) => {
            this.cityPermission = res.dataPermission.cityPermissions;

            this.checked(this.checkedBg);
          });
        }
      });
    } else {
      //获取城市列表
      api.getDataPermission().then((res) => {
        this.cityData = res.body;

        if (this.cityData.length !== 0) {
          this.cityData.forEach((item) => {
            this.cityList.push(item.label);
          });
          this.city = this.cityList[0];
          this.orgCode = this.cityData[0].id;
          this.projectData = this.cityData[0];

          this.cityData[0].children.forEach((item) => {
            this.projectcol.push(item.label);
          });
          this.projectCode = this.cityData[0].children[0].id;
          // 调试用，后面删掉
          // this.projectCode = "FCCDGS001PJ014";
          // this.orgCode = "FCCDGS001";

          this.project = this.projectcol[0];

          //移动端查看推荐个数统计
          api
            .getNumByProjectCode({
              projectCode: this.cityData[0].children[0].id,
            })
            .then((res) => {
              this.currentNum = res.body.currentNum;
              this.projectAllNum = res.body.projectAllNum;
              this.undistributeNum = res.body.undistributeNum;
              this.untreatedNum = res.body.allocatedUntreatNum;
              this.treatedNum = res.body.allocatedProcessedNum;
              this.allPendingAuditNum = res.body.allPendingAuditNum;
              this.allOldbeitnewRecommendNum =
                res.body.allOldbeitnewRecommendNum;
            });

          // 获取用户权限
          this.checked(this.checkedBg);
          // this.$jsBridge.callHandler('getAuthResources', '', (res) => {
          //   this.cityPermission = res.dataPermission.cityPermissions;

          //   this.checked(this.checkedBg);

          // });
        }
      });
    }
    this.$store.commit("SAVE_PROJECT", {
      project: this.project,
      projectCode: this.projectCode,
    });
    setTimeout(() => {
      this.$nextTick(() => {
        this.loadingStatus = false;
      });
    }, 500);
  },
  mounted() {
    this.projectScroll = this.$store.state.projectScroll;
    this.$refs.scrollModule.scrollLeft = this.projectScroll;
    this.checkedBg = this.$store.state.checkedBg;
    // 监听子孙组件传上来的刷新事件
    this.$bus.$on("initRecommendNum", () => {
      this.initNum();
    });
  },
  // 销毁bus的监听事件
  beforeDestroy() {
    this.$bus.$off("initRecommendNum");
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SAVE_PROJECTSCROLL", {
      projectScroll: this.projectScroll,
      checkedBg: this.checkedBg,
      projectCode: this.projectCode,
      city: this.city,
      project: this.project,
    });
    next();
  },
  methods: {
    //跳转到搜索页面
    toSearchHandle() {
      if (!this.projectCode) {
        this.$toast("请先选择项目哦");
        return;
      }
      this.$router.push({
        path: "/oldnew-search",
        query: {
          type: 1,
          projectCode: this.projectCode,
          orgCode: this.orgCode,
        },
      });
    },
    //老带新确认带访更新推荐个数统计
    initNum() {
      api
        .getNumByProjectCode({
          projectCode: this.projectCode,
        })
        .then((res) => {
          this.currentNum = res.body.currentNum;
          this.projectAllNum = res.body.projectAllNum;
          this.undistributeNum = res.body.undistributeNum;
          this.untreatedNum = res.body.allocatedUntreatNum;
          this.treatedNum = res.body.allocatedProcessedNum;
          this.allPendingAuditNum = res.body.allPendingAuditNum;
          this.allOldbeitnewRecommendNum = res.body.allOldbeitnewRecommendNum;
        });
    },
    //获取数据移动端查看推荐列表
    getData(projectCode) {
      let params = {
        projectCode: projectCode,
        requestEntry: 1,
        current: this.nowpage,
        size: 10,
      };

      api.getListByProjectCode(params).then((res) => {
        res.body.records.forEach((item) => {
          this.undistributionList.push(item);
        });

        if (this.nowpage >= res.body.pages) {
          this.finished = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = false;
        }
      });
    },

    // 下拉加载更多
    onLoadMore() {
      if (!this.finished) {
        // 是否还有下一页
        this.nowpage = Number(this.nowpage) + 1;
        this.loading = true;
        this.getData(this.projectCode);
      }
    },
    scrollEvent() {
      this.projectScroll = this.$refs.scrollModule.scrollLeft;
    },
    //选中模块
    checked(e) {
      //已分配未处理
      this.checkedBg = e;
      switch (this.checkedBg) {
        case 0:
          // 数据展示请求
          break;
        case 1:
          // 客户分配请求
          break;
        case 2:
          // 客户跟进请求
          break;
        case 3:
          // 客户待审请求
          break;
      }

      //数据展示
      if (e == 0) {
        if (this.cityPermission.length) {
          this.$store.commit("SAVE_PROJECT", {
            project: this.project,
            projectCode: this.projectCode,
          });

          this.project = "";
          this.projectCode = "";
        }
      } else {
        if (this.cityPermission.length) {
          this.projectCode = this.$store.state.projectCode;
          this.project = this.$store.state.projectName;
        }
      }
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    //选择城市公司
    choiceCity() {
      this.cityshow = true;
    },
    //选择项目
    choiceProject() {
      this.projectshow = true;
    },
    //城市选择确定
    onConfirm(value) {
      this.currentNum = 0;
      this.projectAllNum = 0;
      this.undistributeNum = 0;
      this.untreatedNum = 0;
      this.treatedNum = 0;
      this.allPendingAuditNum = 0;
      this.allOldbeitnewRecommendNum = 0;
      this.cityshow = false;
      this.city = value;
      this.cityData.forEach((item) => {
        if (item.label == value) {
          this.orgCode = item.id;
          if (this.cityPermission.length) {
            if (this.$refs.DataShow) {
              this.$refs.DataShow.getCityData(this.orgCode);
            }
          }
        }
      });

      this.cityData.forEach((item) => {
        if (item.label == value) {
          this.projectData = item;
        }
      });

      this.projectcol = [];

      this.projectData.children.forEach((item) => {
        this.projectcol.push(item.label);
      });
      this.project = this.projectData.children[0].label;
      this.projectCode = this.projectData.children[0].id;
      this.$store.commit("SAVE_PROJECT", {
        project: this.project,
        projectCode: this.projectCode,
      });

      // this.project = "";
      this.currentNum = 0;
      this.projectAllNum = 0;
      this.undistributeNum = 0;
      this.untreatedNum = 0;
      this.treatedNum = 0;
    },
    //项目选择确定
    Confirm(value) {
      this.projectshow = false;
      this.project = value;

      this.projectData.children.forEach((item) => {
        if (value === item.label) {
          this.projectCode = item.id;
        }
      });

      //移动端查看推荐个数统计
      this.initNum();
      this.$store.commit("SAVE_PROJECT", {
        project: this.project,
        projectCode: this.projectCode,
      });
    },

    //城市取消
    onCancel() {
      this.cityshow = false;
    },
    //项目取消
    Cancel() {
      this.projectshow = false;
    },
  },
};
</script>

<style lang="scss">
.old_new {
  .title {
    background-color: #fff;
    height: 90px;

    .component-header-title {
      width: 100%;
      border-bottom: 1px solid #ddddddff;
      padding: 0 20px;
      background-color: #fff;
      height: 90px;
      position: fixed;
      width: 100%;
      top: 0;
      color: #333333;
      line-height: 100px;
      z-index: 9999;

      display: flex;
      .go-back-btn {
        font-size: 36px;
      }
      .title-wrapper {
        flex: auto;
        font-size: 36px;
        text-align: center;
        padding-right: 60px;
        font-weight: 500;
      }
      .custom-btn {
        width: 160px;
        flex: 0 0 160px;
        font-size: 24px;
        position: relative;
        padding-right: 2px;
        & > p {
          width: 100%;
        }
        & > .ellipsis {
          text-align: right;
          padding-right: 15px;
        }
        .drag-down-btn {
          position: absolute;
          right: 0;
          top: 0.3rem;
          display: inline-block;
          transform: rotate(90deg);
        }
      }
    }
  }
  .header_wrap {
    background: url("../../common/images/bc.png") no-repeat;
    background-size: 100% 330px;
    background-color: #ffffff;
    padding: 0 30px;
    height: 320px;
    position: fixed;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }

  .choice_city {
    color: #fff;
    height: 76px;
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 28px;

    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    /deep/.van-picker__toolbar {
      flex-shrink: 32px !important;
      font-weight: 500;
      .van-picker__confirm {
        color: #0d9869;
      }
    }

    .city {
      display: inline-flex;
      justify-content: center;
      align-items: center;

      .location {
        font-size: 38px;
        margin-right: 16px;
        color: #fff;
      }
      span {
        color: #fff;
      }
    }
    .project {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      span {
        color: #fff;
      }
      img {
        width: 16px;
        height: 24px;
        margin-left: 20px;
      }
    }
  }
  .search-btn {
    margin: 24px 0;
    height: 72px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .recommended {
    margin-top: 12px;
    background-color: rgba(1, 2, 2, 0.15);
    .wrap {
      height: 60px;

      border-radius: 6px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      div {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
  .no_wrap {
    margin-top: 12px;
    height: 60px;
  }
  // .main {
  //   margin-top: 340px;
  // }
  .main {
    margin-top: 60px;
    padding: 0 30px;
  }
  .undistributed {
    margin-top: 20px;
    .choice_module {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      overflow-x: auto;
      div {
        flex: none;

        width: 156px;
        height: 88px;
        background: #ffffff;
        box-shadow: 0px 2px 6px 0px rgba(164, 164, 164, 0.4);
        border-radius: 16px;
        display: inline-flex;
        justify-content: space-around;
        flex-direction: column;
        align-items: center;
        padding: 10px 0;
        /* margin: 0 10px; */
        span {
          font-size: 30px;
          color: #333333;
          font-weight: 500;
          &:nth-child(2) {
            font-size: 28px;
            color: #666666;
            font-weight: normal;
          }
        }
      }
    }
    p {
      color: #666666;
      font-size: 28px;
      height: 50px;
      width: 100%;
      text-align: center;
      line-height: 50px;
      span {
        color: #0d9869;
        font-size: 36px;
      }
    }
  }

  .checked {
    background: url("../../common/images/checked.png") no-repeat !important;
    background-size: 100% 100% !important;

    span {
      color: #fff !important;
    }
  }
}
</style>
<style lang="scss" scope>
.old_new {
  .top_wrap {
    height: 340px;
  }
  .person_name {
    max-width: 120px;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;
  }
}
</style>
